"use client"

import React, { useEffect, useState } from "react"
import Login from "../../components/Login/Login"
import Register from "../../components/Register/Register"
import "./styles/globals.scss";
import Sidebar from "../../components/Sidebar/Sidebar"
import ContentTab from "../../components/ContentTab/ContentTab"
import AddScene from "./features/addScene/addScene"
import HomeButton from "../../components/HomeButton/HomeButton"
import SidebarQLHV from "../../components/SidebarQLHV/sidebarQLHV";
import { QLHVProvider } from "../../contexts/QLHVContext";
import { ToastProvider, useToast } from "../../components/Toast";
import HotspotManagerWrapper from "./features/navigation3D/hotspotManagerWrapper";
import { useMultimediaManager } from "../../contexts/MultimediaManager";
import InfoListManagerWrapper from "../../components/InfoListManagerWrapper";
import { useInfoListManager } from "../../contexts/InfoListManager";
import MultimediaPopup from "./features/multimedia/MultimediaPopup";
import MultimediaResourceListModal from "./features/multimedia/MultimediaResourceListModal";
import InfoListPopup from "./features/infoList/InfoListPopup";
import EditMultimediaForm from "./features/multimedia/EditMultimediaForm";
import Textbox from "./features/textbox/textbox";
import ResourceManagementModal from "../../components/ResourceManagementModal/ResourceManagementModal";
import Image2D from "./features/image2d/image2d";
import Video2D from "./features/video2d/video2d";
import OdooSidebar from "../../components/OdooSidebar/OdooSidebar";
import OdooViewer from "./features/odoo/OdooViewer";
import { OdooMenuNode } from "@/types/odoo";
import CustomMenuSidebar from "../../components/CustomMenuSidebar/CustomMenuSidebar";
import CustomMenuViewer from "./features/custom-menu/CustomMenuViewer";
import { isHttpUrl } from "./features/custom-menu/custom-menu-url";
import { CustomMenuItem } from "@/types/custom-menu";
import { useModules } from "@/contexts/ModuleProvider";
import { useIdPath } from "@/contexts/IdPathProvider";
import { cartService } from "@/services/cart.service";
import { useParams, useSearchParams } from "next/navigation";
import AgentGeminiLiveAdmin from "@/components/agent-gemini-live/agent-gemini-live-admin";

// Inner component that uses useToast - must be inside ToastProvider
function AdminContent() {
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [showRegister, setShowRegister] = useState(false)

    const [selectedItem, setSelectedItem] = useState<string | null>(null)
    const [isAddSceneOpen, setIsAddSceneOpen] = useState(false)
    const [isAddSceneCompact, setIsAddSceneCompactState] = useState(false)
    const isAddSceneCompactRef = React.useRef(isAddSceneCompact)
    const setIsAddSceneCompact = (val: boolean) => {
        isAddSceneCompactRef.current = val;
        setIsAddSceneCompactState(val);
    }

    const handleCloseAddScene = () => {
        setIsAddSceneOpen(false);
        setIsAddSceneCompact(false);
        if (selectedItem === "Thêm Scene" || selectedItem === "Thêm cảnh") {
            setSelectedItem(null);
        }
    };

    useEffect(() => {
        if (selectedItem === "Thêm Scene" || selectedItem === "Thêm cảnh") {
            setIsAddSceneOpen(true);
            setIsAddSceneCompact(false);
        } else if (selectedItem !== null) {
            if (!isAddSceneCompactRef.current) {
                setIsAddSceneOpen(false);
            }
        }
    }, [selectedItem]);

    const [rotationValue, setRotationValue] = useState(50)
    const [isSidebarOpen, setIsSidebarOpen] = useState(true)
    const [isQLHVMode, setIsQLHVMode] = useState(false)
    const [sidebarEditData, setSidebarEditData] = useState<any>(null)
    const [targetAssetId, setTargetAssetId] = useState<string | null>(null)
    const [targetResourceAssetId, setTargetResourceAssetId] = useState<string | null>(null)
    const { activeModulesAdmin } = useModules();
    const { idPath } = useIdPath();
    const params = useParams();
    const searchParams = useSearchParams();
    const projectSlug = params.sector && params.project ? `${params.sector}/${params.project}` : undefined;

    // Multimedia popup state for enhanced context menu actions
    const [isResourceListModalOpen, setIsResourceListModalOpen] = useState(false)
    const [selectedEntityId, setSelectedEntityId] = useState<string | null>(null)
    const [selectedEntityType, setSelectedEntityType] = useState<string | null>(null)
    const [isResourceManagementModalOpen, setIsResourceManagementModalOpen] = useState(false)
    const [selectedResourceEntityId, setSelectedResourceEntityId] = useState<string | null>(null)
    const [resourceModalInitialActiveMenu, setResourceModalInitialActiveMenu] = useState<string>("Tổng quan")
    const [resourceModalAutoSelectAssetId, setResourceModalAutoSelectAssetId] = useState<string | undefined>(undefined)
    const [resourceModalAutoSubmitOnLoad, setResourceModalAutoSubmitOnLoad] = useState<boolean>(false)

    // Deep-link loan approval: auto-open loan detail from email link
    const [initialLoanApproveId, setInitialLoanApproveId] = useState<number | null>(null)

    // Cart drawer state for borrow slip creation
    const [cartOpenAsset, setCartOpenAsset] = useState<{ uuid: string; title: string; type: string; thumbnail?: string } | null>(null)

    // Odoo ERP menu sidebar + viewer state
    const [selectedOdooMenu, setSelectedOdooMenu] = useState<OdooMenuNode | null>(null)
    const [odooBaseUrl, setOdooBaseUrl] = useState("")

    // Custom Menu sidebar + viewer state (self-declared menu items, independent of Odoo)
    const [selectedCustomMenuItem, setSelectedCustomMenuItem] = useState<CustomMenuItem | null>(null)
    const handleCustomMenuClick = (item: CustomMenuItem) => {
        if (item.openMode === 'newTab') {
            if (isHttpUrl(item.url)) window.open(item.url, '_blank', 'noopener,noreferrer')
        } else {
            setSelectedCustomMenuItem(item)
        }
    }

    // IoT menu (self-declared menu items, stored under a separate settings variable from Custom Menu)
    const [selectedIotMenuItem, setSelectedIotMenuItem] = useState<CustomMenuItem | null>(null)
    const handleIotMenuClick = (item: CustomMenuItem) => {
        if (item.openMode === 'newTab') {
            if (isHttpUrl(item.url)) window.open(item.url, '_blank', 'noopener,noreferrer')
        } else {
            setSelectedIotMenuItem(item)
        }
    }

    // Toast hook for notifications - NOW INSIDE ToastProvider
    const { showSuccess, showError } = useToast();

    // Initialize multimedia manager to start loading polygon hotspots
    const {
        popupHotspot,
        popupPosition,
        isPopupVisible,
        hidePopup,
        updateMultimedia,
        deleteMultimedia,
        openUpdateForm,
        closeUpdateForm,
        updateFormHotspot,
        isUpdateFormOpen,
        hotspotDataList,
    } = useMultimediaManager();

    const {
        popupInfoList,
        hidePopup: hideInfoListPopup,
        openUpdateForm: openInfoListUpdateForm,
    } = useInfoListManager();

    const handleEditMultimedia = () => {
        if (popupHotspot) {
            // Find the full multimedia data from MultimediaManager
            // Nếu không tìm thấy trong list, dùng tạm popupHotspot
            const fullMultimediaData = hotspotDataList.find(item => item.id === popupHotspot.id) || popupHotspot;

            // --- LOGIC MỚI: Kiểm tra loại đối tượng ---
            // Nếu là Textbox hoặc Writing -> Mở form Textbox (thông qua cơ chế UpdateForm)
            if (fullMultimediaData.type === 'textbox' ||
                fullMultimediaData.entity_type === 'textbox') {

                openUpdateForm(fullMultimediaData); // Hàm này kích hoạt isUpdateFormOpen = true
            }
            // Nếu là Image2D -> Mở form Image2D
            else if (fullMultimediaData.type === 'image2d' ||
                fullMultimediaData.entity_type === 'image2d') {

                openUpdateForm(fullMultimediaData);
            }
            // Nếu là Video2D -> Mở form Video2D
            else if (fullMultimediaData.type === 'video2d' ||
                fullMultimediaData.entity_type === 'video2d') {

                openUpdateForm(fullMultimediaData);
            }
            // Ngược lại -> Mở Sidebar Đa phương tiện
            else {
                // QUAN TRỌNG: Gọi openUpdateForm để MultimediaManager biết hotspot nào đang được edit
                // Điều này giúp không disable hotspot đang edit, cho phép kéo thả
                openUpdateForm(fullMultimediaData);
                setSidebarEditData(fullMultimediaData);
                setSelectedItem("Thêm đa phương tiện"); // Hàm này mở ContentTab Sidebar
            }

            hidePopup();
        }
    };

    const handleDeleteMultimedia = async () => {
        if (!popupHotspot) return;
        const is3D = popupHotspot.type === 'hotspot_3d' || popupHotspot.type === 'hotspot3d';
        const confirmMsg = is3D
            ? `Bạn có chắc chắn muốn xóa model 3D "${popupHotspot.title}" khỏi scene này?\n\n⚠️ Lưu ý: Model asset trong thư viện sẽ không bị xóa, chỉ gỡ model khỏi scene hiện tại.`
            : `Bạn có chắc chắn muốn xóa "${popupHotspot.title}" khỏi scene này?`;
        if (window.confirm(confirmMsg)) {
            try {
                await deleteMultimedia(popupHotspot.id);
                hidePopup();
            } catch (error) {
                console.error('Error deleting multimedia:', error);
                alert('Có lỗi xảy ra khi xóa. Vui lòng thử lại.');
            }
        }
    };

    // Multimedia popup enhanced handlers
    const handleViewResources = (entityId: string) => {
        hidePopup();
        setSelectedEntityId(entityId);
        setIsResourceListModalOpen(true);
    };

    const handleOpenInResourceManagement = (entityId: string) => {
        setSelectedResourceEntityId(entityId);
        setIsResourceManagementModalOpen(true);
        hidePopup();
    };

    const handleOpenInDisplayManagement = (entityId: string) => {
        setTargetAssetId(entityId);
        setIsResourceManagementModalOpen(true);
        hidePopup();
    };

    const handleAddToCart = async (entityId: string) => {
        try {
            const result = await cartService.addToCart(idPath || "", { asset_id: entityId });
             showSuccess("Đã thêm vào giỏ mượn");
            // Delay hidePopup to allow toast to be visible
            setTimeout(() => hidePopup(), 100);
        } catch (error: any) {
            console.error("[Admin] Error adding to cart:", error?.response?.data || error);
            showError(error?.response?.data?.message || "Không thể thêm vào giỏ mượn");
        }
    };

    const handleCreateBorrowSlip = (entityId: string) => {
        try {
            // Find the hotspot data to get title and type for cart
            const hotspotData = hotspotDataList.find(item => String(item.link) === entityId || String(item.id) === entityId);
            const assetTitle = hotspotData?.title || hotspotData?.name || "Asset";
            const assetType = hotspotData?.type || hotspotData?.asset_type_name || "";

            // Set cartOpenAsset BEFORE opening modal to ensure the state change is registered
            setCartOpenAsset({
                uuid: entityId,
                title: assetTitle,
                type: assetType,
                thumbnail: hotspotData?.thumbnail || hotspotData?.cover_image
            });

            // Open ResourceManagementModal with "Giỏ mượn" view and auto-select/auto-submit
            setSelectedResourceEntityId(entityId);
            setResourceModalInitialActiveMenu("Giỏ mượn");
            setResourceModalAutoSelectAssetId(entityId);
            setResourceModalAutoSubmitOnLoad(true);
            setIsResourceManagementModalOpen(true);

            // Hide popup after setting cart asset
            hidePopup();
        } catch (error: any) {
            console.error("[Admin] Error creating borrow slip:", error?.response?.data || error);
            showError(error?.response?.data?.message || "Không thể tạo phiếu mượn");
        }
    };

    const handleViewViewInfo = (entityId: string, entityType: string) => {
        // For views, entityId is the scene_name or link identifier
        // Navigate to the view or show info modal
        setSelectedEntityId(entityId);
        setSelectedEntityType(entityType);
        showSuccess(`Xem thông tin view: ${entityId}`);
        hidePopup();
    };

    // Info list deletion now handled by InfoListManagerWrapper


    const handleSaveMultimedia = async (data: any) => {
        if (updateFormHotspot) {
            await updateMultimedia(updateFormHotspot.id, data);
        }
    };

    useEffect(() => {
        const loggedIn = localStorage.getItem("isLoggedIn")
        setIsLoggedIn(loggedIn === "true")

        // Listen for session expiration to show a beautiful toast BEFORE redirecting
        const handleSessionExpired = () => {
            showError("Phiên đăng nhập đã hết hạn, hệ thống sẽ tự động đăng xuất...", "Thông báo");
        };

        window.addEventListener('session_expired_event', handleSessionExpired);
        return () => window.removeEventListener('session_expired_event', handleSessionExpired);
    }, [showError])

    // Deep-link: detect ?loan_approve=<loanId> in URL and auto-open the loan
    useEffect(() => {
        const loanApproveParam = searchParams?.get('loan_approve');
        if (loanApproveParam) {
            const loanId = parseInt(loanApproveParam, 10);
            if (!isNaN(loanId) && loanId > 0) {
                setInitialLoanApproveId(loanId);
                setResourceModalInitialActiveMenu("Quản lý phiếu mượn");
                setIsResourceManagementModalOpen(true);
            }
            // Clean the query param from URL to prevent re-triggering
            if (typeof window !== 'undefined') {
                const url = new URL(window.location.href);
                url.searchParams.delete('loan_approve');
                window.history.replaceState({}, '', url.toString());
            }
        }
    }, [searchParams])

    const handleLogin = () => {
        localStorage.setItem("isLoggedIn", "true")
        setIsLoggedIn(true)
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleLogout = () => {
        localStorage.removeItem("isLoggedIn")
        setIsLoggedIn(false)
        setSelectedItem(null)
        setIsQLHVMode(false)
    }

    const handleItemClick = (itemTitle: string) => {
        setSelectedItem(itemTitle)
        setTargetAssetId(null)
        setTargetResourceAssetId(null)
        // Nếu nhấn vào "Tổng quan", chuyển sang chế độ QLHV
        if (itemTitle === 'Tổng quan') {
            setIsQLHVMode(true)
        }
    }

    // Function để mở Navigation3D tab từ popup
    const handleOpenNavigation3D = () => {
        setSelectedItem("Điều hướng 3D");
        setIsQLHVMode(false); // Đảm bảo không ở chế độ QLHV
    };

    const handleQLHVItemClick = (itemTitle: string) => {
        setSelectedItem(itemTitle)
        setTargetAssetId(null)
        setTargetResourceAssetId(null)
    }

    const closeTab = () => {
        setSelectedItem(null)
        setIsQLHVMode(false)
        setSidebarEditData(null) // Clear edit data when closing tab
        setTargetAssetId(null) // Clear target asset ID when closing tab
        setTargetResourceAssetId(null) // Clear target resource asset ID when closing tab
        closeUpdateForm() // Reset updateFormHotspot để enable lại tất cả hotspot
    }

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    // Handle cart drawer close
    const handleCartDrawerClose = () => {
        setCartOpenAsset(null);
    }

    // if (!isLoggedIn) {
    //     return (
    //         <div className="fixed inset-0 z-50 bg-white flex items-center justify-center">
    //             {showRegister ? (
    //                 <Register
    //                     onRegisterSuccess={() => setShowRegister(false)}
    //                     onShowLogin={() => setShowRegister(false)}
    //                 />
    //             ) : (
    //                 <Login
    //                     onLogin={handleLogin}
    //                     onShowRegister={() => setShowRegister(true)}
    //                 />
    //             )}
    //         </div>
    //     )
    // }

    return (
        <QLHVProvider isQLHVMode={isQLHVMode}>
            <div className="relative w-full h-screen overflow-hidden">

                {isQLHVMode ? activeModulesAdmin['managementResource'] && (
                    <SidebarQLHV
                        onClose={closeTab}
                        onItemClick={handleQLHVItemClick}
                        selectedItem={selectedItem}
                    />
                ) : (
                    <>
                        <Sidebar
                            isOpen={isSidebarOpen}
                            onItemClick={handleItemClick}
                            selectedItem={selectedItem}
                            rotationValue={rotationValue}
                            setRotationValue={setRotationValue}
                        />

                        {/* Main Content */}
                        <HomeButton
                            rotationValue={rotationValue}
                            toggleSidebar={toggleSidebar}
                            isSidebarOpen={isSidebarOpen}
                            hasActiveTab={!!selectedItem && !isQLHVMode}
                            selectedItem={selectedItem}
                        />

                        {activeModulesAdmin['customMenu'] ? (
                            <CustomMenuSidebar
                                idPath={idPath || ""}
                                onItemClick={handleCustomMenuClick}
                                showContractorManagement={!!activeModulesAdmin['contractorManagement']}
                                onContractorManagementClick={() => handleItemClick("Quản lý nhà thầu")}
                                showIotMenu={!!activeModulesAdmin['iotMenu']}
                                onIotItemClick={handleIotMenuClick}
                            />
                        ) : (
                            activeModulesAdmin['odoo'] && (
                                <OdooSidebar
                                    idPath={idPath || ""}
                                    onMenuClick={(menu, baseUrl) => {
                                        setSelectedOdooMenu(menu)
                                        setOdooBaseUrl(baseUrl)
                                    }}
                                    selectedMenuId={selectedOdooMenu?.id}
                                    showContractorManagement={!!activeModulesAdmin['contractorManagement']}
                                    onContractorManagementClick={() => handleItemClick("Quản lý nhà thầu")}
                                    showIotMenu={!!activeModulesAdmin['iotMenu']}
                                    onIotItemClick={handleIotMenuClick}
                                />
                            )
                        )}
                    </>
                )}

                {/* Content Tab */}
                {selectedItem && selectedItem !== "Thêm Scene" && selectedItem !== "Thêm cảnh" && (
                    // <div className={`relative h-full ${isSidebarOpen ? 'ml-[240px]' : 'ml-[60px]'}`}>
                        <ContentTab selectedItem={selectedItem} onClose={closeTab} isSidebarOpen={isQLHVMode ? false : isSidebarOpen} sidebarEditData={sidebarEditData} targetAssetId={targetAssetId} targetResourceAssetId={targetResourceAssetId} onOpenInDisplay={(assetId) => { setTargetAssetId(assetId); setSelectedItem("Quản lý hiển thị"); }} onOpenInResource={(assetId) => { setTargetResourceAssetId(assetId); setSelectedItem("Quản lý tài nguyên"); }} cartOpenAsset={cartOpenAsset} onCartDrawerClose={handleCartDrawerClose} />
                    // </div>
                )}

                {isAddSceneOpen && (
                    <AddScene
                        onClose={handleCloseAddScene}
                        isSidebarOpen={isSidebarOpen}
                        isCompactMode={isAddSceneCompact}
                        onCompactModeChange={setIsAddSceneCompact}
                    />
                )}
                {activeModulesAdmin['hotspot'] && <HotspotManagerWrapper onOpenNavigation3D={handleOpenNavigation3D} />}

                {/* Multimedia Popup */}
                {popupHotspot && popupPosition && (activeModulesAdmin['multiMedia'] || popupHotspot.type === 'hotspot_3d' || popupHotspot.type === 'hotspot3d') && (
                    <MultimediaPopup
                        hotspot={popupHotspot}
                        position={popupPosition}
                        isVisible={isPopupVisible}
                        onEdit={handleEditMultimedia}
                        onDelete={handleDeleteMultimedia}
                        onClose={hidePopup}
                        onViewResources={handleViewResources}
                        onOpenInResourceManagement={handleOpenInResourceManagement}
                        onOpenInDisplayManagement={handleOpenInDisplayManagement}
                        onAddToCart={handleAddToCart}
                        onCreateBorrowSlip={handleCreateBorrowSlip}
                        onViewViewInfo={handleViewViewInfo}
                    />
                )}

                {/* Multimedia Resource List Modal */}
                <MultimediaResourceListModal
                    isOpen={isResourceListModalOpen}
                    onClose={() => setIsResourceListModalOpen(false)}
                    entityId={selectedEntityId || ""}
                    projectSlug={projectSlug}
                    idPath={idPath || ""}
                />

                {/* Resource Management Modal */}
                <ResourceManagementModal
                    isOpen={isResourceManagementModalOpen}
                    onClose={() => { 
                        setIsResourceManagementModalOpen(false); 
                        setTargetAssetId(null); 
                        setSelectedResourceEntityId(null);
                        setResourceModalInitialActiveMenu("Tổng quan"); 
                        setResourceModalAutoSelectAssetId(undefined); 
                        setResourceModalAutoSubmitOnLoad(false); 
                        setInitialLoanApproveId(null); 
                        setCartOpenAsset(null);
                    }}
                    isSidebarOpen={isSidebarOpen}
                    initialTargetResourceAssetId={selectedResourceEntityId}
                    initialTargetAssetId={targetAssetId}
                    initialActiveMenu={resourceModalInitialActiveMenu}
                    cartOpenAsset={cartOpenAsset}
                    autoSelectAssetId={resourceModalAutoSelectAssetId}
                    autoSubmitOnLoad={resourceModalAutoSubmitOnLoad}
                    initialLoanApproveId={initialLoanApproveId}
                />

                {activeModulesAdmin['infoList'] && (
                    <InfoListManagerWrapper
                        onOpenInfoListManagement={() => {
                            setSelectedItem("Danh sách thông tin");
                            setSidebarEditData(popupInfoList);
                        }}
                    />
                )}

                {/* Edit Multimedia Form - Chỉ hiển thị khi không có sidebar Multimedia đang mở */}
                {isUpdateFormOpen && updateFormHotspot && !sidebarEditData && activeModulesAdmin['multiMedia'] && (
                    (updateFormHotspot.entity_type === 'textbox' ||
                        updateFormHotspot.type === 'textbox') ? (
                        <Textbox
                            onClose={closeUpdateForm}
                            isSidebarOpen={true}
                            mode="update"
                            initialData={updateFormHotspot}
                        />
                    ) : (updateFormHotspot.entity_type === 'image2d' ||
                        updateFormHotspot.type === 'image2d') ? (
                        <Image2D
                            onClose={closeUpdateForm}
                            isSidebarOpen={true}
                            mode="update"
                            initialData={updateFormHotspot}
                        />
                    ) : (updateFormHotspot.entity_type === 'video2d' ||
                        updateFormHotspot.type === 'video2d') ? (
                        <Video2D
                            onClose={closeUpdateForm}
                            isSidebarOpen={true}
                            mode="update"
                            initialData={updateFormHotspot}
                        />
                    ) : (
                        <EditMultimediaForm
                            hotspot={updateFormHotspot}
                            onClose={closeUpdateForm}
                            onSave={handleSaveMultimedia}
                        />
                    )
                )}

                {selectedOdooMenu && (
                    <OdooViewer
                        menu={selectedOdooMenu}
                        baseUrl={odooBaseUrl}
                        onClose={() => setSelectedOdooMenu(null)}
                    />
                )}

                {selectedCustomMenuItem && (
                    <CustomMenuViewer
                        item={selectedCustomMenuItem}
                        onClose={() => setSelectedCustomMenuItem(null)}
                    />
                )}

                {selectedIotMenuItem && (
                    <CustomMenuViewer
                        item={selectedIotMenuItem}
                        onClose={() => setSelectedIotMenuItem(null)}
                    />
                )}

                {/* Gemini Live Agent for admin — floating button + avatar modal */}
                {activeModulesAdmin['agentGeminiLive'] && <AgentGeminiLiveAdmin />}
            </div>
        </QLHVProvider>
    )
}

// Wrapper component that provides ToastProvider
export default function Admin() {
    return (
        <ToastProvider>
            <AdminContent />
        </ToastProvider>
    )
}
